module.exports = __webpack_public_path__ + "img/distribute.78e8b0c5.svg";